<template>
    <div>
        <section>
            <div class="inner row5">
                <h1 class="boardTitle">회원관리</h1>
                <div>
                    <div class="row4">
                        <div class="topContent flex">
                            <div class="left flex">
                                <p>총 <span>{{ personalCount + enterpriseCount }}</span>건</p>
                                <div class="tops">
                                    <div class="tabMenu secItemMG">
                                        <button class="accountTabBtn" :class="{active: currentTab===0}" v-on:click="setTabChange(0, 'ROLE_USER')">
                                            개인 <span> {{personalCount}} </span>
                                        </button>
                                        <button class="accountTabBtn" :class="{active: currentTab===1}" v-on:click="setTabChange(1, 'ROLE_CORP')">
                                            기업 <span> {{enterpriseCount}} </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <input type="text" class="searchInput" v-model="searchText" @keyup.enter="searchUser"/>
                                <input type="button" value="검 색" class="searchBtn searchBtnCmmn" @click="searchUser"/>
                                <input type="button" value="검색초기화" class="searchResetBtn searchBtnCmmn" @click="resetSearchText"/>
                                <div class="btnBox blankLeft inlineB">
                                    <button type="button" class="greenBtn smBtn" @click="goWrite()">등록</button>
                                    <button type="button" class="orangeBtn smBtn" @click="deleteBtn()">삭제</button>
                                </div>
                            </div> 
                        </div>
                        <div class="joinTabContent">
                            <!-- tab 1 -->
                            <div>
                                <div class="tableContainer"> 
                                    <div class="sampleTemplate">
                                        <b-table
                                        id="table"
                                        :fields="fields"
                                        :items="getUser"
                                        :per-page="perPage"
                                        :current-page="currentPage"
                                        @head-clicked="onHeadClicked"
                                        @row-clicked="onRowClicked"
                                        :sort-by.sync="sortBy"
                                        :sort-desc.sync="sortDesc"
                                        :select-mode="selectMode"
                                        ref="table"
                                        selectable
                                        @row-selected="onRowSelected"
                                        hover
                                        show-empty
                                        empty-text="회원이 존재하지 않습니다."
                                        >
                                            <template #emptyfiltered="scope">
                                                <h4>{{ scope.emptyFilteredText }}</h4>
                                            </template>
                                            <template #cell(EMAIL)="data">
                                                <span v-html="data.value" @click="showDetail(data.item.IDX, data.item.ROLE_NAME)"></span>
                                            </template>
                                            <template #cell(selected)="{ rowSelected }">
                                                <template v-if="rowSelected">
                                                    <span aria-hidden="true">&check;</span>
                                                    <span class="sr-only">Selected</span>
                                                </template>
                                                <template v-else>
                                                    <span aria-hidden="true">&nbsp;</span>
                                                    <span class="sr-only">Not selected</span>
                                                </template>
                                            </template>
                                        </b-table>
                                        <b-pagination
                                        v-model="currentPage"
                                        :total-rows="totalCnt"
                                        :per-page="perPage"
                                        aria-controls="table">
                                        </b-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>   
</template>

<script>
import axios from '@/axios/axios'

export default {
    name: 'AccountManagement',
    data () {
        return {
            currentTab: 0,
            searchText: this.$route.query.searchText ? this.$route.query.searchText : "",
            personalCount: 0,
            enterpriseCount: 0,
            perPage: 10,
            currentPage: 1,
            roleName : "ROLE_USER",
            totalCnt: 0,
            selectMode: 'multi',
            selected: [],
            sortBy: 'REGDATE',
            sortDesc: false,
            fields: [
                {
                    key: 'selected',
                    label: '선택',
                    class: 'text-center',
                },
                {
                    key: 'ROWNUM',
                    label: 'NO.',
                    class: 'text-center'
                },
                {
                    key: 'ID',
                    label: '아이디',
                    sortable: false,
                    class: 'text-center',
                },
                {
                    key: 'NAME',
                    label: '이름',
                    sortable: false,
                    class: 'text-center',
                },
                {
                    key: 'EMAIL',
                    label: '이메일',
                    sortable: false,
                    class: 'text-center',
                },
                {
                    key: 'REGDATE',
                    label: '가입일시',
                    sortable: false,
                    class: 'text-center',
                }

            ]
        }
    },
    methods:{
        onRowClicked(/*item*/){
            //alert('item clicked')
        },
        onRowSelected(items) {
            this.selected = items
        },
        onHeadClicked(key) {
            if(key === 'selected'){
				if(this.selected.length == this.totalCnt){
					this.$refs.table.clearSelected()
				}
				else{
					this.$refs.table.selectAllRows()
				}
			}
        },
        goWrite() {
            this.$router.push('/admin/accountManagementWrite')
        },
        getUser(){
            return axios
                .post('/api/admin/user/getUserList', {
                    currentPage: this.currentPage,
                    perPage: this.perPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc,
                    searchText : this.searchText,
                    roleName : this.roleName
                })
                .then(response => {
                    const items = response.data.items;
                    this.totalCnt = response.data.totalCnt;
                    this.personalCount = response.data.personalCount;
                    this.enterpriseCount = response.data.enterpriseCount;
                    
                    return items;
                })
                .catch(error => {
                    console.log("error: "+error)
                    return []
                })
        },
        resetSearchText(){
            this.searchText = "";
            let path = `/admin/accountManagement`;
            if (this.$route.fullPath !== path){
                this.$router.push({ path:'/admin/accountManagement' });
            }
            this.searchUser();
        },
        searchUser(){
            let path = `/admin/accountManagement?searchText=${this.searchText}`;
            if (this.$route.fullPath !== path){
                this.$router.push({ path:'/admin/accountManagement', query: { searchText : this.searchText }});
            }
            this.$refs.table.refresh();
        },
        setTabChange(currentTab, roleName){
            this.currentTab = currentTab;
            this.roleName = roleName;

            this.$refs.table.refresh();
        },
        showDetail(idx, roleName){
            if(roleName == "ROLE_USER"){
                this.$router.push({ name : 'accountManagementUserProfile', params : { idx : idx }});
            }
            else {
                this.$router.push({ name : 'accountManagementCorpProfile', params : { idx : idx }});
            }
        },
        deleteBtn(){
            let selected = this.selected;
            if(selected.length == 0){
                this.$alert("알림", "삭제할 글을 선택해주세요.");
                return false;
            }
            
            var response = this.$createConfirmResponse()
            this.$confirm("알림", `${selected.length}개의 항목을 삭제하시겠습니까?`, "확인", "취소", response, {
                'closed': () => {
                    if(response.result){
                        let paramDatas = { list : selected };
                        axios.post('/api/admin/user/delete', paramDatas)
                        .then(result => {
                            if(result.status == 200){
                                this.$alert("알림", "삭제가 완료되었습니다.", "확인", {
                                    'closed': () => {
                                        this.$refs.table.refresh();
                                    }
                                });                      
                            }
                            else {
                                this.$alert("알림", "회원정보 삭제에 실패하였습니다.");
                            }
                        })
                        .catch((error) => {
                            this.$alert("알림", "회원정보 삭제에 실패하였습니다."+ error.response.data);
                        });
                    }
                }
            });
        }
    }
}

</script>

<style scoped>
    .countSpan {
        display: inline-block;
        padding: 5px 20px;
        font-size: 24px;
        line-height: 35px;
    }
    .grayBtn {
        background: #5D5D5D;
        border: 1px solid #BDBDBD;
        color: #FFF;
    }
    .grayBorderBtn {
        border: 1px solid #5D5D5D;
        color: #5D5D5D;
    }
    .left.flex {
        align-items: flex-end;
    }
    .secItemMG button:nth-of-type(2) {
        margin: 0 0 0 10px;
    }
</style>

<style scoped lang="scss">
    .sampleTemplate ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
        @import "~bootstrap-vue/dist/bootstrap-vue.min";
    }
</style>